import type { LabelGeoJSON } from "~/lib/map/types";

// Register the Japanese language to be rendered by deck.gl.
// cf. https://gunmagisgeek.com/blog/deck-gl/7660
export const geoJsonsToCharacterSet = (geoJsons: LabelGeoJSON[]) =>
  Array.from(new Set(geoJsons.flatMap((item) => Array.from(item.properties.label))));
